module.exports = __webpack_public_path__ + "static/media/turn.f1efb7bc.png";